import { SliceClass } from 'interfaces';

export class LandingPage {
  url: string;
  slices: SliceClass[];
  title: string;
  metaDescription: string;
  metaRobotsNoIndex: boolean;
  productCode?: string;

  constructor(
    url: string,
    slices: SliceClass[],
    title: string,
    metaDescription: string,
    metaRobotsNoIndex = false,
    productCode?: string
  ) {
    this.url = url;
    this.slices = slices;
    this.title = title;
    this.metaDescription = metaDescription;
    this.metaRobotsNoIndex = metaRobotsNoIndex;
    this.productCode = productCode;

    if (this.slices[0]) {
      this.slices[0].isHeadSlice = true;
    }
  }
}
